<script setup>
import { ref } from "vue";

const props = defineProps({
    elId: {
        Type: String,
        default: "",
    },
    label: String,
    value: String,
    options: Array,
    otherOptionLabel: String,
    otherOptionPlaceholder: {
        type: String,
        default: "Other Options ....",
    },
    error: String,

    widthLabel: {
        type: Number,
        default: 3,
    },
    widthInput: {
        type: Number,
        default: 9,
    },
});

const selValue = ref(props.value);
const dataOther = ref("");
const isOther = ref(false);
const optionOther = { id: "other", description: props.otherOptionLabel };

const emits = defineEmits(["update:value"]);

const emitSelection = (value, otherValue = "") => {
    let curValue = value;
    if (value == "other") {
        isOther.value = true;
        curValue = otherValue;
    } else {
        isOther.value = false;
        dataOther.value = "";
    }
    emits("update:value", curValue);
};

const checkOther = (value, options) => {
    let check = value ? true : false;
    const others = options.filter((item) => {
        if (item.id == value) {
            check = false;
        }
    });

    return check;
};

isOther.value = checkOther(props.value, props.options);
if (isOther.value) {
    selValue.value = "other";
    dataOther.value = props.value;
}
</script>

<template>
    <div class="row" :class="{ 'question-error': error }">
        <label
            v-if="label != ''"
            :for="elId"
            class="col-12 label-size fw-bold mb-2"
        >
            {{ label }}
        </label>
        <div class="col-12">
            <select
                :id="elId"
                class="form-select"
                :class="{ 'is-invalid': error }"
                @input="emitSelection($event.target.value, '')"
            >
                <option disabled selected>
                    {{ $t("plugins.vue_multiselect.placeholder") }}
                </option>
                <option
                    v-for="option in options.concat([optionOther])"
                    :key="option.id"
                    :value="option.id"
                    :selected="option.id == value"
                >
                    {{ option.description }}
                </option>
            </select>
            <div class="mt-2">
                <input
                    class="form-control form-control-sm mt-1"
                    :class="{ 'd-none': !isOther }"
                    type="text"
                    v-model="dataOther"
                    @keyup="emitSelection('other', $event.target.value)"
                    :placeholder="otherOptionPlaceholder"
                />
            </div>
        </div>
    </div>

    <div v-if="error" class="row">
        <div class="col-12 text-danger font-error">
            {{ error }}
        </div>
    </div>
</template>
